import { useQuery } from "react-query";
import axios from "../../services/axios";
import { default as axiosLib } from "axios";
import { ResiParams, ResiResponse } from "../../types";
import qs from "query-string";

const useGetResi = (params: ResiParams) => {
    const endpoint = qs.stringifyUrl({
        url: "/api/getresi",
        query: params,
    });
    return useQuery(
        ["getresi", { ...params }],
        () => axios.get<ResiResponse>(endpoint).then((res) => res.data.data),
        {
            retry: (failureCount, error) => {
                if (axiosLib.isAxiosError(error) && error.response?.status === 403) {
                    return false;
                }
                return failureCount < 3;
            },
            refetchOnWindowFocus: (query) => {
                const err = query.state.error;
                if (axiosLib.isAxiosError(err) && err.response?.status === 403) {
                    return false;
                }
                return true;
            },
        }
    );
};

export default useGetResi;
